export * from "./utils"
export * from "./permissions"

export const userRoles = [
  { label: "Client", value: "client" },
  { label: "Admin", value: "admin" },
  { label: "Viewer", value: "viewer" },
  { label: "Editor", value: "editor" },
]
